/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useRef } from 'react';
import { Text, TEXT_SIZE, useTooltip } from '@veeam/components';
import { onMouseEnterHandlerDecorator, TooltipText } from '@veeam/components/lib/Grid/cellRenderers/helpers';

import type { ControlInjectProps, TextProps } from '@veeam/components';

import { deriveText } from './utils';
import { ColumnTexts } from '../../../../enums';

export interface TextColumnProps extends TextProps {
    children: React.ReactNode | null;
    defaultValue?: string;
    maxTooltipWidth?: string;
    tooltipText?: React.ReactNode | string;
}

export const TextColumn: React.FC<TextColumnProps> = (props) => {
    const { children, defaultValue = ColumnTexts.DashSymbol, maxTooltipWidth = '400px', tooltipText, ...restProps } = props;
    const ref = useRef<HTMLElement | null>(null);
    const text = children !== undefined && children !== null && children !== '' ? children : defaultValue;

    return (
        useTooltip({
            delayTimeout: 500,
            maxWidth: maxTooltipWidth,
            renderContent: () => <TooltipText truncate={false} size={TEXT_SIZE.s}>{deriveText(tooltipText || text)}</TooltipText>,
            render: (tooltipProps: ControlInjectProps) => (
                <Text
                    {...tooltipProps}
                    ref={ref}
                    truncate
                    onMouseEnter={onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref)}
                    {...restProps}
                    style={{
                        color: 'inherit',
                        textAlign: 'inherit',
                        ...restProps.style,
                    }}
                >
                    {text}
                </Text>
            ),
        })
    );
};
